<section id="blog" class="blog-teaser">
  <div class="container">
    <h2>{{ 'BLOG_TEASER.SECTION_TITLE' | translate }}</h2>

    <div class="teaser-grid">
      <div class="teaser-box" *ngFor="let post of posts">
        <h3 class="teaser-title">{{ post.title }}</h3>
        <p class="teaser-desc">{{ post.description }}</p>
        <a [routerLink]="['/blog', post.slug]" class="cta-button">
          {{ 'BLOG_TEASER.READ_POST' | translate }}
        </a>
      </div>
    </div>

    <a routerLink="/blog" (click)="scrollToTop($event)" class="btn-all">
      {{ 'BLOG_TEASER.VIEW_ALL' | translate }}
    </a>
  </div>
</section>
